<template>
  <div class="container">
    <div class="logo">
      <img
        src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/logo.png"
        alt
      />
    </div>
    <div class="btn_box">
      <div class="btn" @click="goPage(3)">
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/list_item1_00.png"
          alt=""
        />
        <div class="info">
          <p>轻度</p>
          <p class="line1">XXXXXXXXXXXXXXXXXXX</p>
        </div>
      </div>
      <div class="btn" @click="goPage(4)">
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/list_item1_01.png"
          alt=""
        />
        <div class="info">
          <p>中度</p>
          <p class="line1">XXXXXXXXXXXXXXXXXXX</p>
        </div>
      </div>
      <div class="btn">
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/list_item1_02.png"
          alt=""
        />
        <div class="info" @click="goPage(5)">
          <p>重度</p>
          <p class="line1">XXXXXXXXXXXXXXXXXXX</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mianZhen_list_item1",
  data() {
    return {};
  },
  methods: {
    goPage(id) {
      this.$router.push({ path: "/mianzheng/info", query: { id: id } });
    },
    goPage(id) {
      if (id == undefined) {
        this.$router.push({ path: "/mianzheng/list/list_item1" });
        return;
      }
      this.$router.push({
        path: "/mianzheng/info",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-image: url("https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/h5/bgimg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  .logo {
    height: 1rem;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      pointer-events: none;
    }
  }
  .btn_box {
    padding: 0 1.04rem 0 1.15rem;
    margin-top: 0.4rem;
    .btn {
      width: 5.31rem;
      height: 2rem;
      background: rgba(126, 13, 198, 0.5);
      border: 0.02rem solid rgba(255, 255, 255, 0.15);
      border-radius: 0.17rem;
      padding: 0.5rem 0.6rem;
      margin-top: 0.27rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:active {
        background: rgba(126, 13, 198, 0.7);
        border: 0.02rem solid rgba(255, 255, 255, 0.2);
      }
      img {
        width: 1rem;
        height: 1rem;
        pointer-events: none;
      }
      .info {
        padding-left: 0.3rem;
        width: calc(100% - 1rem);
        p {
          line-height: 0.5rem;
          &:first-child {
            color: #fff;
            font-size: 0.36rem;
            text-shadow: 0.02rem 0.1rem 0.16rem rgba(7, 1, 2, 0.3);
          }
          &:last-child {
            color: #fff;
            font-size: 0.25rem;
            text-shadow: 0.02rem 0.1rem 0.16rem rgba(7, 1, 2, 0.3);
          }
        }
      }
    }
  }
}
</style>
